import { isCI, isDebug, isDev, isProd, isTTY, stage } from '@lsk4/env';

export { isCI, isDebug, isDev, isProd, isTTY, stage };
